import React from 'react';
import PropTypes from 'prop-types';

import './social-icons.scss';

const SocialIcons = ({ instagram, twitter, linkedin, darkMode }) => (
  <div>
    <div
      className={`social-icons social-icons__instagram ${
        darkMode ? 'social-icons--dark' : 'social-icons--light'
      }`}
    >
      <a href={instagram} rel='noopenner noreferrer' target='_blank'>
        <svg
          width='25'
          height='25'
          viewBox='0 0 25 25'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M12.1667 0C5.4472 0 0 5.4472 0 12.1667C0 18.8861 5.4472 24.3333 12.1667 24.3333C18.8861 24.3333 24.3333 18.8861 24.3333 12.1667C24.3333 5.4472 18.8861 0 12.1667 0ZM9.49168 5.71699C10.1838 5.68549 10.405 5.67779 12.1673 5.67779H12.1653C13.9281 5.67779 14.1484 5.68549 14.8406 5.71699C15.5314 5.74863 16.0032 5.85799 16.4169 6.01846C16.8441 6.18406 17.205 6.40577 17.566 6.76672C17.9269 7.12739 18.1486 7.48942 18.3149 7.91621C18.4744 8.3288 18.5839 8.80033 18.6164 9.49113C18.6475 10.1833 18.6556 10.4045 18.6556 12.1667C18.6556 13.929 18.6475 14.1497 18.6164 14.8418C18.5839 15.5323 18.4744 16.004 18.3149 16.4167C18.1486 16.8434 17.9269 17.2054 17.566 17.5661C17.2054 17.927 16.8439 18.1493 16.4173 18.315C16.0044 18.4755 15.5324 18.5849 14.8415 18.6165C14.1494 18.648 13.9289 18.6557 12.1665 18.6557C10.4043 18.6557 10.1833 18.648 9.49113 18.6165C8.80047 18.5849 8.3288 18.4755 7.91594 18.315C7.48943 18.1493 7.1274 17.927 6.76685 17.5661C6.40604 17.2054 6.18434 16.8434 6.01846 16.4166C5.85813 16.004 5.74876 15.5325 5.717 14.8417C5.68563 14.1495 5.67779 13.929 5.67779 12.1667C5.67779 10.4045 5.6859 10.1832 5.71686 9.491C5.74795 8.80046 5.85745 8.3288 6.01833 7.91607C6.18461 7.48942 6.40631 7.12739 6.76726 6.76672C7.12794 6.4059 7.48997 6.1842 7.91675 6.01846C8.32934 5.85799 8.80087 5.74863 9.49168 5.71699Z'
            className='social-icons__base-color'
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M11.5852 6.8472C11.6982 6.84703 11.8198 6.84708 11.951 6.84714L12.1673 6.8472C13.8998 6.8472 14.1052 6.85342 14.7893 6.88451C15.422 6.91344 15.7654 7.01916 15.9941 7.10798C16.2969 7.22559 16.5128 7.36618 16.7398 7.5933C16.9669 7.82041 17.1075 8.03671 17.2254 8.33953C17.3142 8.56799 17.4201 8.91137 17.4489 9.54404C17.48 10.2281 17.4867 10.4336 17.4867 12.1653C17.4867 13.897 17.48 14.1025 17.4489 14.7866C17.4199 15.4192 17.3142 15.7626 17.2254 15.9911C17.1078 16.2939 16.9669 16.5095 16.7398 16.7365C16.5127 16.9636 16.2971 17.1042 15.9941 17.2218C15.7657 17.3111 15.422 17.4165 14.7893 17.4454C14.1053 17.4765 13.8998 17.4833 12.1673 17.4833C10.4346 17.4833 10.2292 17.4765 9.54518 17.4454C8.91251 17.4162 8.56914 17.3105 8.34027 17.2217C8.03745 17.1041 7.82115 16.9635 7.59404 16.7364C7.36692 16.5093 7.22633 16.2935 7.10845 15.9905C7.01963 15.7621 6.91378 15.4187 6.88498 14.786C6.85389 14.102 6.84767 13.8965 6.84767 12.1637C6.84767 10.4309 6.85389 10.2265 6.88498 9.54242C6.91391 8.90974 7.01963 8.56637 7.10845 8.33764C7.22606 8.03482 7.36692 7.81852 7.59404 7.59141C7.82115 7.36429 8.03745 7.2237 8.34027 7.10582C8.569 7.01659 8.91251 6.91115 9.54518 6.88208C10.1438 6.85504 10.3758 6.84693 11.5852 6.84558V6.8472ZM15.631 7.92468C15.2011 7.92468 14.8523 8.27306 14.8523 8.70309C14.8523 9.13298 15.2011 9.48176 15.631 9.48176C16.0609 9.48176 16.4097 9.13298 16.4097 8.70309C16.4097 8.2732 16.0609 7.92441 15.631 7.92441V7.92468ZM8.83487 12.1667C8.83487 10.3264 10.3269 8.83441 12.1671 8.83434C14.0074 8.83434 15.499 10.3264 15.499 12.1667C15.499 14.007 14.0075 15.4984 12.1672 15.4984C10.3269 15.4984 8.83487 14.007 8.83487 12.1667Z'
            className='social-icons__base-color'
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M12.1673 10.0039C13.3618 10.0039 14.3303 10.9722 14.3303 12.1669C14.3303 13.3614 13.3618 14.3299 12.1673 14.3299C10.9726 14.3299 10.0043 13.3614 10.0043 12.1669C10.0043 10.9722 10.9726 10.0039 12.1673 10.0039V10.0039Z'
            className='social-icons__base-color'
          />
        </svg>
      </a>
    </div>
    <div
      className={`social-icons social-icons__twitter ${
        darkMode ? 'social-icons--dark' : 'social-icons--light'
      }`}
    >
      <a href={twitter} rel='noopenner noreferrer' target='_blank'>
        <svg
          width='25'
          height='25'
          viewBox='0 0 25 25'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M12.7222 0C6.00276 0 0.555557 5.4472 0.555557 12.1667C0.555557 18.8861 6.00276 24.3333 12.7222 24.3333C19.4417 24.3333 24.8889 18.8861 24.8889 12.1667C24.8889 5.4472 19.4417 0 12.7222 0ZM12.3834 10.3102L12.3579 9.88923C12.2813 8.79808 12.9536 7.80144 14.0174 7.41481C14.4089 7.27735 15.0727 7.26016 15.5067 7.38045C15.6769 7.432 16.0003 7.60383 16.2301 7.75848L16.6471 8.04201L17.1066 7.89595C17.3619 7.81863 17.7024 7.68975 17.8555 7.60383C18.0002 7.52651 18.1279 7.48355 18.1279 7.50932C18.1279 7.65538 17.813 8.1537 17.5492 8.42864C17.1917 8.81526 17.2939 8.84963 18.0172 8.59188C18.4513 8.44582 18.4598 8.44582 18.3747 8.60906C18.3236 8.69498 18.0598 8.99569 17.7789 9.27063C17.3024 9.74317 17.2768 9.79472 17.2768 10.1899C17.2768 10.8 16.9875 12.0715 16.6981 12.7675C16.162 14.0734 15.0131 15.4223 13.8642 16.101C12.2472 17.0547 10.0941 17.2953 8.28141 16.7368C7.67718 16.5478 6.63892 16.0667 6.63892 15.9808C6.63892 15.955 6.9538 15.9206 7.33677 15.912C8.13674 15.8948 8.93671 15.6715 9.61753 15.2762L10.0771 15.0013L9.54945 14.8209C8.80054 14.5631 8.12823 13.9703 7.95802 13.4118C7.90696 13.2314 7.92398 13.2228 8.40056 13.2228L8.89416 13.2142L8.47715 13.0166C7.98355 12.7675 7.5325 12.3465 7.31123 11.9169C7.14954 11.6076 6.94529 10.8257 7.00486 10.7656C7.02188 10.7398 7.2006 10.7914 7.40485 10.8601C7.99206 11.0749 8.06865 11.0233 7.72824 10.6625C7.08997 10.0095 6.89423 9.03865 7.2006 8.11934L7.34528 7.70693L7.90696 8.2654C9.05585 9.39091 10.409 10.0611 11.9579 10.2587L12.3834 10.3102Z'
            className='social-icons__base-color'
          />
        </svg>
      </a>
    </div>
    <div
      className={`social-icons social-icons__linkedin ${
        darkMode ? 'social-icons--dark' : 'social-icons--light'
      }`}
    >
      <a href={linkedin} rel='noopenner noreferrer' target='_blank'>
        <svg
          width='25'
          height='25'
          viewBox='0 0 25 25'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M12.2778 0C5.55832 0 0.111115 5.4472 0.111115 12.1667C0.111115 18.8861 5.55832 24.3333 12.2778 24.3333C18.9972 24.3333 24.4444 18.8861 24.4444 12.1667C24.4444 5.4472 18.9972 0 12.2778 0ZM5.95193 10.0769H8.70916V18.3613H5.95193V10.0769ZM8.89078 7.51429C8.87288 6.70202 8.29202 6.08334 7.34879 6.08334C6.40555 6.08334 5.7889 6.70202 5.7889 7.51429C5.7889 8.30974 6.38733 8.94623 7.313 8.94623H7.33062C8.29202 8.94623 8.89078 8.30974 8.89078 7.51429ZM15.4782 9.88246C17.2926 9.88246 18.6528 11.0668 18.6528 13.6113L18.6527 18.3613H15.8956V13.9292C15.8956 12.8159 15.4966 12.0563 14.4985 12.0563C13.7367 12.0563 13.283 12.5684 13.0837 13.063C13.0108 13.2403 12.9929 13.4873 12.9929 13.7349V18.3615H10.2354C10.2354 18.3615 10.2717 10.8546 10.2354 10.0772H12.9929V11.2506C13.3589 10.6865 14.0143 9.88246 15.4782 9.88246Z'
            className='social-icons__base-color'
          />
        </svg>
      </a>
    </div>
  </div>
);

SocialIcons.defaultProps = {
  instagram: '',
  twitter: '',
  linkedin: '',
  darkMode: true,
};

SocialIcons.propTypes = {
  instagram: PropTypes.string,
  twitter: PropTypes.string,
  linkedin: PropTypes.string,
  darkMode: PropTypes.bool,
};

export default SocialIcons;
